import toastr from 'toastr';

import Localization from '../config/localization';

class Notifications {
  static clear(element?: JQuery, clearOptions?: { force: boolean }): void {
    if (!element) {
      return toastr.clear();
    } else if (!clearOptions) {
      return toastr.clear(element);
    }

    return toastr.clear(element, clearOptions);
  }

  static config(options: ToastrOptions = {} as ToastrOptions) {
    return (toastr.options = options);
  }

  static error(message = Localization.Errors.default, title = '', options: ToastrOptions = {}) {
    if (!message && !title) {
      return undefined;
    }
    return toastr.error(message, title, options);
  }

  static info(message = '', title = '', options: ToastrOptions = {}) {
    if (!message && !title) {
      return undefined;
    }
    return toastr.info(message, title, options);
  }

  static remove() {
    return toastr.remove();
  }

  static success(message = '', title = '', options: ToastrOptions = {}) {
    if (!message && !title) {
      return undefined;
    }
    return toastr.success(message, title, options);
  }

  static warning(message = '', title = '', options: ToastrOptions = {}) {
    if (!message && !title) {
      return undefined;
    }
    return toastr.warning(message, title, options);
  }
}

export default Notifications;
